import { LeaderboardData } from "lib/types/LeaderboardTypes";
import { asyncActionCreators, actionCreator } from "../../lib/util/ReduxUtils";
import { ScopeInfo } from "../../lib/types/MiscTypes";

import * as Api from "../../Api";
import { current } from "@reduxjs/toolkit";

export const getGroupNotifications = asyncActionCreators<
	ScopeInfo & { rootGroup?: string; anonymise?: boolean },
	{
		[groupName: string]: {
			active: any[];
			complete: any[];
		};
	}
>(
	"[NOTIFICATIONS] GET_GROUP_NOTIFICATIONS",
	async (action, dispatch, getState) => {
		const { fleetId, group } = action.payload;
		const currentNotifications = getState().Notifications.notifications.value;
		const groupKey = group ? `${fleetId}/${group}` : fleetId;
		const existingNotifications = currentNotifications?.[groupKey];

		if (existingNotifications || !fleetId) {
			return currentNotifications;
		}

		const result = await Api.fetchGroupNotifications.submit({
			query: { group: group || undefined },
			params: { fleetId },
		});

		return {
			[groupKey]: {
				active: result.data.notifications
					?.map((notification: any, index: number) => {
						if (notification.sendTime > Date.now()) {
							return notification;
						}

						return null;
					})
					.filter(Boolean),
				complete: result.data.notifications
					?.map((notification: any, index: number) => {
						if (notification.sendTime <= Date.now()) {
							return notification;
						}

						return null;
					})
					.filter(Boolean),
			},
		};
	},
);

export const addGroupNotification = asyncActionCreators<
	ScopeInfo & { notification: any },
	{
		[groupName: string]: {
			active: any[];
			complete: any[];
		};
	}
>(
	"[NOTIFICATIONS] ADD_GROUP_NOTIFICATION",
	async (action, dispatch, getState) => {
		const { fleetId, group, notification } = action.payload;
		const notifications = getState().Notifications.notifications.value;
		const groupKey = group ? `${fleetId}/${group}` : fleetId;
		const existingNotifications = notifications?.[groupKey];

		if (!existingNotifications || !fleetId) {
			return notifications;
		}

		if (!notifications[groupKey]) {
			notifications[groupKey] = {
				active: [],
				complete: [],
			};
		}

		if (notification.sendTime > Date.now()) {
			notifications[groupKey].active.push(notification);
		} else {
			notifications[groupKey].complete.push(notification);
		}

		return notifications;
	},
);

export const updateNotification = actionCreator<any>(
	"[NOTIFICATIONS] UPDATE_NOTIFICATION",
);
